
<!--
  <h1 mat-dialog-title>{{ "PLANNER.reasonNonProgrammableOrders" | translate }}</h1>
-->
<div mat-dialog-content>


  <form [formGroup]="form" class="form-container">
  <mat-form-field style="width: 100%;" appearance="fill" class="form-activities">
    <mat-label>{{ 'TYPOLOGIESRELATIONSHIPSBETWEENPRACTICES.type_of_relationship' | translate }}</mat-label>
    <mat-select  matNativeControl formControlName="typologiesRelationshipsBetweenPracticeId">
      <mat-option *ngFor="let type of typologiesRelationshipsBetweenPractices" [value]="''+type.id">
        <!-- | async -->
        {{ "TYPOLOGIESRELATIONSHIPSBETWEENPRACTICES."+ type.code | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  </form>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="form.value" [disabled]="!form.valid">{{ "LABEL.SAVE" | translate }}</button>
  <button mat-button [mat-dialog-close]="">{{ "LABEL.CANCEL" | translate }}</button>
</div>